// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"CB","replayButton":"CC","cta":"CD","replayIcon":"CE","buttonWrapper":"CF"};